import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Technologies from './components/Technologies';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
// import SocialMediaServices from './components/SocialMediaServices';
import Terms from './pages/Terms';
import Fale from './pages/Fale';

import Politica from './pages/Política';
// import { FaCogs, FaProjectDiagram, FaHeadset, FaLightbulb } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <Router>
      <Navbar />
      <div className="container-fluid p-0">
        <Routes>
          {/* Página Inicial */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <About />
                <Services />
                {/* <SocialMediaServices /> */}

                <WhyUs />
                <Technologies />
                <FAQ />
                <Contact />
              </>
            }
          />

          <Route path="/termos-de-uso" element={<Terms />} />
          <Route path="/politica-de-privacidade" element={<Politica />} />
          <Route path="/fale-conosco" element={<Fale />} />
        </Routes>

        {/* Rodapé */}
        <Footer />
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;
